﻿var vm;

(function () {
    'use strict';

    var controllerId = 'oos';

    angular.module('app.controllers').controller(controllerId, oos)
    oos.$inject = ['common', 'datacontext', '$http', '$scope', '$stateParams', '$translate', '$sce'];

    function oos(common, datacontext, $http, $scope, $stateParams, $translate, $sce) {
        vm = this;

        vm.carrierId = 0;
        vm.carrierName = "";
        vm.carrierFilterDisabled = false;

        vm.validFamilies = ['DRY', 'REF'];
        vm.familiesOriginal = [];

        vm.selectOption = { Id: 0, Name: $translate.instant('views.oos.select') };
        vm.listSizeTypeOriginal = [];
        vm.currentYear = (new Date()).getFullYear();

        vm.oosData = [];

        function init() {
            common.activateController().then(function (data) { });
            vm.initializeData();
            vm.setBasicInformation();
            vm.clearCriteria();
            vm.getGeneralFilters();
            vm.getCarriers();
            vm.getoosFilters();
        }

        // # region Filter Functions

        vm.clearCriteria = function () {
            vm.criteria = {
                depotId: vm.listDepots ? (vm.listDepots.length > 0 ? vm.listDepots[0].Id : 0) : 0,
                familyIds: [],
                carrierIds: [],
                sizeTypeModel: vm.listSizeType ? (vm.listSizeType.length > 0 ? vm.listSizeType[0] : null) : null,
                year: vm.listYears ? (vm.listYears.length > 0 ? vm.listYears[vm.selectCurrentYearIndex()].Id : 0) : 0,
                weekFrom: vm.listWeek ? (vm.listWeek.length > 0 ? vm.listWeek[0].Id : 0) : 0,
                weekTo: vm.listWeek ? (vm.listWeek.length > 0 ? vm.listWeek[0].Id : 0) : 0,
            };
        }

        vm.fnSetDefaultDepot = function () {
            var authData = common.localStorageService.get('authorizationData');
            if (authData) {
                var currentYardId = authData.ModelRequester.CurrentYardId;
                if (currentYardId !== undefined)
                    vm.criteria.depotId = Number(currentYardId);
            }
        }

        vm.getGeneralFilters = function () {
            vm.initializeDepot();
            vm.initializeFamily();

            return datacontext.oos.getFilters(vm.roleSelected).then(function (data) {
                if (data) {
                    if (data.FamilyList != null && data.FamilyList.length > 0) {
                        vm.familiesOriginal = angular.copy(data.FamilyList);
                        angular.forEach(data.FamilyList, function (family, key) {
                            if (vm.validFamilies.indexOf(family.Code) != -1)
                                vm.listFamilies.push({ id: family.Id, label: family.Name });
                        });
                    }

                    if (data.Depot != null && data.Depot.length > 0) {
                        vm.listDepots = data.Depot;
                        vm.criteria.depotId = vm.listDepots[0].Id;
                    }
                    vm.fnSetDefaultDepot();

                    if (data.SizeType !== null && data.SizeType.length > 0) {
                        vm.listSizeType = angular.copy(data.SizeType);
                        vm.listSizeTypeOriginal = angular.copy(data.SizeType);
                        vm.listSizeType.unshift(vm.selectOption);
                        vm.criteria.sizeTypeModel = vm.listSizeType[0];
                    }
                    vm.Label = data.Label;
                }
            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        };

        vm.getCarriers = function () {
            vm.initializeCarrier();
            return datacontext.oos.getCarrierList().then(function (data) {
                if (data) {
                    angular.forEach(data, function (value, key) {
                        vm.listCarriers.push({ id: value.Id, label: value.Name });
                    });
                    vm.updateCarrierFilter();
                }
            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        };

        vm.getoosFilters = function () {
            vm.initializeYears();
            vm.initializeWeek();

            vm.loadWeekInfo();

            return datacontext.oos.getoosFilters().then(function (data) {
                if (data) {
                    if (data.Years != null && data.Years.length > 0) {
                        vm.listYears = angular.copy(data.Years);
                        vm.criteria.year = vm.listYears[vm.selectCurrentYearIndex()].Id;
                    }
                }

            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        };

        vm.loadWeekInfo = function () {
            vm.listWeek = vm.generateYearWeeks();
            vm.listWeek.unshift(vm.selectOption);

            vm.criteria.weekFrom = vm.listWeek[0].Id;
            vm.criteria.weekTo = vm.listWeek[0].Id;
        }

        vm.initializeData = function () {
            vm.oosData = [];

            vm.oosDataSource = new kendo.data.DataSource({
                data: vm.oosData
            });

            vm.gridOptions = {
                dataSource: vm.oosDataSource,
                sortable: false,
                pageable: false,
                groupable: false,
                resizable: true,
                columns: [
                    {
                        title: $translate.instant('views.oos.week'),
                        field: "Week",
                        width: "8%",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    },
                    {
                        title: $translate.instant('views.oos._20_Dry'),
                        field: "_20_Dry",
                        width: "6%",
                        template: "<span style='height: 12px; width: 12px; border-radius: 50%; display: inline-block; background-color:{{dataItem._20_Dry_Color}}' ></span>&nbsp;<strong>{{dataItem._20_Dry}}</strong>",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    },
                    {
                        title: $translate.instant('views.oos._20_Reef'),
                        field: "_20_Reef",
                        width: "6%",
                        template: "<span style='height: 12px; width: 12px; border-radius: 50%; display: inline-block; background-color:{{dataItem._20_Reef_Color}}' ></span>&nbsp;<strong>{{dataItem._20_Reef}}</strong>",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    },
                    {
                        title: $translate.instant('views.oos._20_Open_Top'),
                        field: "_20_Open_Top",
                        width: "7%",
                        template: "<span style='height: 12px; width: 12px; border-radius: 50%; display: inline-block; background-color:{{dataItem._20_Open_Top_Color}}' ></span>&nbsp;<strong>{{dataItem._20_Open_Top}}</strong>",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    },
                    {
                        title: $translate.instant('views.oos._20_HC_Dry'),
                        field: "_20_HC_Dry",
                        width: "7%",
                        template: "<span style='height: 12px; width: 12px; border-radius: 50%; display: inline-block; background-color:{{dataItem._20_HC_Dry_Color}}' ></span>&nbsp;<strong>{{dataItem._20_HC_Dry}}</strong>",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    },
                    {
                        title: $translate.instant('views.oos._40_HC_Dry'),
                        field: "_40_HC_Dry",
                        width: "7%",
                        template: "<span style='height: 12px; width: 12px; border-radius: 50%; display: inline-block; background-color:{{dataItem._40_HC_Dry_Color}}' ></span>&nbsp;<strong>{{dataItem._40_HC_Dry}}</strong>",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    },
                    {
                        title: $translate.instant('views.oos._40_Dry'),
                        field: "_40_Dry",
                        width: "6%",
                        template: "<span style='height: 12px; width: 12px; border-radius: 50%; display: inline-block; background-color:{{dataItem._40_Dry_Color}}' ></span>&nbsp;<strong>{{dataItem._40_Dry}}</strong>",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    },
                    {
                        title: $translate.instant('views.oos._40_Reef'),
                        field: "_40_Reef",
                        width: "6%",
                        template: "<span style='height: 12px; width: 12px; border-radius: 50%; display: inline-block; background-color:{{dataItem._40_Reef_Color}}' ></span>&nbsp;<strong>{{dataItem._40_Reef}}</strong>",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    },
                    {
                        title: $translate.instant('views.oos._40_Hard_Top'),
                        field: "_40_Hard_Top",
                        width: "7%",
                        template: "<span style='height: 12px; width: 12px; border-radius: 50%; display: inline-block; background-color:{{dataItem._40_Hard_Top_Color}}' ></span>&nbsp;<strong>{{dataItem._40_Hard_Top}}</strong>",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    },
                    {
                        title: $translate.instant('views.oos._40_Open_Top'),
                        field: "_40_Open_Top",
                        width: "7%",
                        template: "<span style='height: 12px; width: 12px; border-radius: 50%; display: inline-block; background-color:{{dataItem._40_Open_Top_Color}}' ></span>&nbsp;<strong>{{dataItem._40_Open_Top}}</strong>",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    },
                    {
                        title: $translate.instant('views.oos._40_HC_Reef'),
                        field: "_40_HC_Reef",
                        width: "6%",
                        template: "<span style='height: 12px; width: 12px; border-radius: 50%; display: inline-block; background-color:{{dataItem._40_HC_Reef_Color}}' ></span>&nbsp;<strong>{{dataItem._40_HC_Reef}}</strong>",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    },
                    {
                        title: $translate.instant('views.oos._40_HC_Reef_CA'),
                        field: "_40_HC_Reef_CA",
                        width: "7%",
                        template: "<span style='height: 12px; width: 12px; border-radius: 50%; display: inline-block; background-color:{{dataItem._40_HC_Reef_CA_Color}}' ></span>&nbsp;<strong>{{dataItem._40_HC_Reef_CA}}</strong>",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    },
                    {
                        title: $translate.instant('views.oos._40_HC_Reef_SF'),
                        field: "_40_HC_Reef_SF",
                        width: "7%",
                        template: "<span style='height: 12px; width: 12px; border-radius: 50%; display: inline-block; background-color:{{dataItem._40_HC_Reef_SF_Color}}' ></span>&nbsp;<strong>{{dataItem._40_HC_Reef_SF}}</strong>",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    },
                    {
                        title: $translate.instant('views.oos._40_HC_Open_Top'),
                        field: "_40_HC_Open_Top",
                        width: "7%",
                        template: "<span style='height: 12px; width: 12px; border-radius: 50%; display: inline-block; background-color:{{dataItem._40_HC_Open_Top_Color}}' ></span>&nbsp;<strong>{{dataItem._40_HC_Open_Top}}</strong>",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    },
                    {
                        title: $translate.instant('views.oos._45_HC_Dry'),
                        field: "_45_HC_Dry",
                        width: "6%",
                        template: "<span style='height: 12px; width: 12px; border-radius: 50%; display: inline-block; background-color:{{dataItem._45_HC_Dry_Color}}' ></span>&nbsp;<strong>{{dataItem._45_HC_Dry}}</strong>",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    }
                ]
            };
        };

        vm.setBasicInformation = function () {
            var authData = common.localStorageService.get('authorizationData');
            vm.roleSelected = authData ? authData.userRole : "";
            vm.isAdmin = vm.roleSelected === "COPAdminP" ? true : false;

            var associateCarrier = common.localStorageService.get('GetBusinessPartnerUserRolesQuery');

            if (associateCarrier && associateCarrier.Name) {
                vm.carrierId = associateCarrier.BusinessPartnerId;
                vm.carrierName = associateCarrier.Name;
            }
        }

        // #region Filters Events

        vm.changeFamily = function () {
            vm.listSizeType = [];

            if (vm.criteria.familyIds === null || vm.criteria.familyIds.length === 0) {
                vm.listSizeType = angular.copy(vm.listSizeTypeOriginal);
            } else {
                angular.forEach(vm.criteria.familyIds, function (family, key) {
                    angular.forEach(vm.listSizeTypeOriginal, function (sizeTypeItem, key2) {
                        var familyCode = vm.getFamilyCodeById(family.id);
                        if (familyCode == sizeTypeItem.Aditional) {
                            vm.listSizeType.push(sizeTypeItem);
                        }
                    });
                });
            }

            vm.listSizeType.unshift(vm.selectOption);
            vm.sizeTypeModel = vm.listSizeType[0];
        };

        // #endregion

        // # endregion

        // #region Helper Functions

        vm.updateCarrierFilter = function () {
            if (vm.listCarriers && vm.carrierId !== 0) {
                vm.listCarriers.forEach(function (value, key) {
                    if (value.id == vm.carrierId) {
                        vm.criteria.carrierIds = [value];
                        vm.carrierFilterDisabled = true;
                    }
                });
            }
            else
                vm.carrierFilterDisabled = false;
        }

        vm.getFamilyCodeById = function (familyId) {
            var family = $(vm.familiesOriginal).filter(function (e, v) { return v.Id == familyId })[0];
            return family ? family.Code : null;
        };

        vm.GetIdsFromMultiSelectList = function (selectedItems) {
            var ids = [];
            angular.forEach(selectedItems, function (val, key) { ids.push(val.id); });
            return ids;
        }

        vm.selectCurrentYearIndex = function () {
            return vm.listYears.findIndex(x => x.Id === vm.currentYear);
        }

        vm.generateYearWeeks = function () {
            var weeks = Array.from(new Array(53), (val, index) => index + 1);
            var weeklist = [];
            angular.forEach(weeks, function (value, key) {
                weeklist.push({ Id: value, Name: $translate.instant('views.oos.week') + value });
            });

            return weeklist;
        }

        vm.setDefaultfamiliesWhenEmpty = function () {
            if (vm.criteria.familyIds.length === 0) {
                var dryFamilyId = $(vm.familiesOriginal).filter(function (e, v) { return v.Code === "DRY"; })[0].Id;
                var refFamilyId = $(vm.familiesOriginal).filter(function (e, v) { return v.Code === "REF"; })[0].Id;
                vm.criteria.familyIds.push({ id: dryFamilyId });
                vm.criteria.familyIds.push({ id: refFamilyId });
            }
        };

        vm.refresReport = function () {
            var mainReport = angular.element('#mainReport').data("kendo-grid");

            if (mainReport) {
                mainReport.refresh();
            }
        }

        // #endregion

        // #region Main Functions(Search/Clear)

        vm.clearReport = function () {
            vm.oosData = [];
            vm.oosDataSource = { data: vm.oosData };
            vm.clearCriteria();
            vm.refresReport();
        };

        vm.searchReport = function () {
            var valid = true;

            if (vm.criteria.year < vm.currentYear && (vm.criteria.weekFrom === 0 || vm.criteria.weekTo === 0)) {
                toastr.info($translate.instant('views.oos.selectSpecificWeekRange'));
                valid = false;
            }

            if (!valid)
                return;

            vm.setDefaultfamiliesWhenEmpty();

            var criteria = {
                depotId: vm.criteria.depotId,
                familyIds: vm.GetIdsFromMultiSelectList(vm.criteria.familyIds),
                carrierIds: vm.GetIdsFromMultiSelectList(vm.criteria.carrierIds),
                sizeTypeId: vm.criteria.sizeTypeModel.Id > 0 ? vm.criteria.sizeTypeModel.Id : null,
                year: vm.criteria.year,
                weekFrom: vm.criteria.weekFrom > 0 ? vm.criteria.weekFrom : null,
                weekTo: vm.criteria.weekTo ? vm.criteria.weekTo : null
            };

            datacontext.oos.getoosList(criteria).then(function (data) {
                if (data.Result === 1) {
                    if (data) {
                        vm.oosData = data.OOSResult;
                        vm.setoosDataSource();
                        vm.refresReport();
                    } else {
                        vm.clearReport();
                    }
                }
                else
                    vm.clearReport();
            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        };

        vm.setoosDataSource = function () {
            vm.oosDataSource = {
                data: vm.oosData
            };
        }

        vm.exportReport = function () {
            if (vm.oosData.length == 0) {
                toastr.info($translate.instant('views.oos.noDataToExport'));
                return;
            }

            var criteria = {
                depotId: vm.criteria.depotId,
                familyIds: vm.GetIdsFromMultiSelectList(vm.criteria.familyIds),
                carrierIds: vm.GetIdsFromMultiSelectList(vm.criteria.carrierIds),
                sizeTypeId: vm.criteria.sizeTypeModel.Id > 0 ? vm.criteria.sizeTypeModel.Id : null,
                year: vm.criteria.year,
                weekFrom: vm.criteria.weekFrom > 0 ? vm.criteria.weekFrom : null,
                weekTo: vm.criteria.weekTo ? vm.criteria.weekTo : null
            };

            datacontext.oos.getoosListExcel(criteria, "OOS");
        };

        // #endregion

        // #region Inicialization Functions

        vm.initializeDepot = function () {
            vm.listDepots = [];
        };

        vm.initializeFamily = function () {
            vm.listFamilies = [];
        };

        vm.initializeCarrier = function () {
            vm.listCarriers = [];
        };

        vm.initializeSizeType = function () {
            vm.listSizeType = [];
        };

        vm.initializeYears = function () {
            vm.listYears = [];
        }

        vm.initializeWeek = function () {
            vm.listWeek = [];
        }

        // #endregion

        init();

        vm.trustAsHtml = function (string) {
            return $sce.trustAsHtml(string);
        };
    }
})();